<template>
  <div>
    <template v-if="businessType && supplierId && currency">
      <template v-if="checkboxOptionList.length > 0">
        <el-row :gutter="10">
          <el-col :span="12">
            <div class="mb6 selectRegion">
              <div class="title">Search & Add Pricing Items</div>
              <div>
                <div class="searchInput">
                  <el-input v-model="searchContent" clearable placeholder="Search items…"></el-input>
                </div>
                <div class="itemWrap">
                  <template v-if="filteredOptionList.length > 0">
                    <el-checkbox-group v-model="leftSelectedList">
                      <div class="checkboxWrap" v-for="item in filteredOptionList" :key="`checkbox-${item.id}`">
                        <el-checkbox :label="item">
                          <div class="enbr feed">
                            <span class="fwb">[{{ item.serviceCode }}]</span>
                            <span class="mr2">{{ item.description }}</span>
                            <span class="grey">{{ currencyAndAmountFormat(item.currency, item.serviceFee) }}</span>
                          </div>
                        </el-checkbox>
                      </div>
                    </el-checkbox-group>
                  </template>
                  <div class="emptyHint" v-else>No matching services</div>
                </div>
              </div>
            </div>
            <el-button type="primary" size="mini" plain @click="selectedHandle">Add Selected</el-button>
          </el-col>
          <el-col :span="12">
            <div class="mb6 selectRegion">
              <div class="title">Package Items</div>
              <div class="itemWrap">
                <div class="wdb100 el-checkbox-group" v-if="rightSelectedList.length > 0">
                  <div class="checkboxWrap" v-for="(item, index) in rightSelectedList" :key="`selected-${item.id}`">
                    <div class="enbr feed justify-between el-checkbox">
                      <div class="pl0 el-checkbox__label">
                        <span class="fwb">[{{ item.serviceCode }}]</span>
                        <span class="mr2">{{ item.description }}</span>
                        <span class="grey">{{ currencyAndAmountFormat(item.currency, item.serviceFee) }}</span>
                      </div>
                      <div class="pl10 el-checkbox__input">
                        <el-button type="text" size="mini" class="pd0 fwb red el-icon-close" @click="removeItem(index)"></el-button>
                        <el-button type="text" size="mini" class="pd0 fwb el-icon-top" :disabled="index == 0" @click="moveItem(index, -1)"></el-button>
                        <el-button
                          type="text"
                          size="mini"
                          class="pd0 fwb el-icon-bottom"
                          :disabled="index == rightSelectedList.length - 1"
                          @click="moveItem(index, 1)"
                        ></el-button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="emptyHint" v-else>No service added</div>
              </div>
            </div>
            <div class="servicePiceTotal">
              <span class="mr4">List Total:</span>
              <span :class="{ red: listTotalCalculation(rightSelectedList)?.isMismatch }">
                {{ listTotalCalculation(rightSelectedList)?.text }}
              </span>
            </div>
          </el-col>
        </el-row>
      </template>
      <div class="notSelectTipBg" v-else>
        <span>No services match this currency, business type, and supplier.</span>
      </div>
    </template>
    <div class="notSelectTipBg" v-else>
      <span>Select currency, business type, and supplier first.</span>
    </div>
  </div>
</template>

<script>
import priceCountMixin from "@/mixins/priceCountMixin";
import formatterMixin from "@/mixins/formatterMixin";
export default {
  mixins: [priceCountMixin, formatterMixin],
  props: {
    businessType: {
      type: String,
      default: () => "",
    },
    currency: {
      type: String,
      default: () => "",
    },
    supplierId: {
      type: String,
      default: () => "",
    },
    checkboxOptionList: {
      type: Array,
      default: () => [],
    },
    echoSelectedServiceList: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      searchContent: "",
      debouncedSearchContent: "", // 存储防抖后的搜索关键字
      searchTimeout: null, // 存储定时器以实现防抖
      leftSelectedList: [],
      rightSelectedList: this.echoSelectedServiceList, // 仅初始化
    };
  },
  computed: {
    // 模糊查询计算属性，根据防抖后的关键字过滤列表
    filteredOptionList() {
      const keyword = this.debouncedSearchContent.trim().toLowerCase();
      // 当输入框为空时，恢复展示完整的 checkboxOptionList 列表
      if (!keyword) {
        return this.checkboxOptionList;
      }
      // 忽略大小写，并支持部分匹配
      return this.checkboxOptionList.filter(item => {
        const serviceCode = (item.serviceCode || "").toString().toLowerCase();
        const description = (item.description || "").toString().toLowerCase();
        const currency = (item.currency || "").toString().toLowerCase();
        const serviceFee = (item.serviceFee || "").toString().toLowerCase();

        return serviceCode.includes(keyword) || description.includes(keyword) || currency.includes(keyword) || serviceFee.includes(keyword);
      });
    },
  },
  watch: {
    // 监听输入框变化，应用 300ms 的防抖机制
    searchContent(newVal) {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        this.debouncedSearchContent = newVal;
      }, 300);
    },
    echoSelectedServiceList: {
      handler(newVal) {
        this.rightSelectedList = newVal;
      },
      deep: true, // 如果是数组或对象，建议开启深度监听
      immediate: true, // 如果想在组件创建时立即执行一次，开启此项
    },
  },
  methods: {
    // 将选中项添加到右侧选择区域
    selectedHandle() {
      const idList = this.rightSelectedList.map(item => item.id);
      this.leftSelectedList.forEach(ele => {
        if (!idList.includes(ele.id)) {
          this.rightSelectedList.push(ele);
        }
      });
      this.leftSelectedList = [];
      // 给父级传值
      const ids = this.rightSelectedList.map(data => data.id);
      this.$emit("input", ids); // 兼容 v-model 默认行为
      this.$emit("update:value", ids); // 兼容 .sync 修饰符
    },
    // 排序操作
    moveItem(index, direction) {
      const list = this.rightSelectedList;
      const nextIndex = index + direction;
      if (nextIndex < 0 || nextIndex >= list.length) return;
      const currentItem = list.splice(index, 1)[0];
      list.splice(nextIndex, 0, currentItem);
      // 给父级传值
      const ids = list.map(data => data.id);
      this.$emit("input", ids); // 兼容 v-model 默认行为
      this.$emit("update:value", ids); // 兼容 .sync 修饰符
    },
    // 监听删除操作
    removeItem(index) {
      this.rightSelectedList.splice(index, 1);
      const ids = this.rightSelectedList.map(data => data.id);
      this.$emit("input", ids);
      this.$emit("update:value", ids);
    },
  },
};
</script>

<style lang="scss" scoped>
.searchInput {
  padding: 8px 8px 0;
}

.itemWrap {
  height: 300px;
  overflow-y: auto;

  .emptyHint {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    font-size: 14px;
    color: #909399;
  }
}

.servicePiceTotal {
  height: 36px;
  line-height: 34px;
  font-weight: bold;
  color: #1a3a5c;
  font-size: 13px;
  padding: 0 8px;
  background: #f0f7ff;
  border: 1px solid #cbd5e1;
  border-radius: 2px;
  margin-top: 8px;
}
</style>
